exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-helper-hidden-accessible {\r\n    display: none !important;\r\n}\r\n\r\n.ui-menu {\r\n    width: 30% !important;\r\n    font-size: 20px;\r\n    max-height: 10em;\r\n    background-color: white;\r\n    box-shadow: 1px 1px 1px black;\r\n}\r\n\r\n.ui-menu-item {\r\n    color: black;\r\n    list-style-type: none;\r\n    padding: 3px;\r\n}\r\n\r\n.ui-menu-item:hover div,.ui-menu-item:hover {\r\n    background-color: #022699;\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.ui-menu-item:nth-child(n+6) {\r\n    display: none;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/autocomplete.css
// module id = 48
// module chunks = 0